<template>
  <div v-if="isManager || isAssistant" class="mt-3">
    <div class="text-end mb-2">
      <button
        class="btn btn-sm btn-info rounded-pill"
        title="Reiniciar Medição"
        @click="restartMeasure"
      >
        Reiniciar Medição
      </button>
    </div>
    <UploadXmlFile
      v-if="step === 'UploadXMLFile'"
      @forwardXMLReader="forwardXMLReader"
    />
    <MeasureItensMoviment
      v-if="step === 'MeasureItens'"
      :idMov="moviment.id"
      :noteValue="measure.noteValue"
      :noteValueNet="measure.noteValueNet"
      :xmlJustify="measure.xmlJustify"
      :disableButtonSaveMeasure="disableButtonSaveMeasure"
      @fowardToSaveMeasure="fowardToSaveMeasure"
    />
  </div>
  <p v-else class="text-center mt-3 mb-0">
    Seu perfil não permite criar medições
  </p>
</template>

<script>
import UploadXmlFile from '@/components/documents/commons/UploadXmlFile.vue'
import MeasureItensMoviment from '@/components/documents/moviments/MeasureItensMoviment.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'NewMeasureMoviment',

  props: {
    moviment: {
      type: Object,
      required: true,
    },
  },

  components: {
    UploadXmlFile,
    MeasureItensMoviment,
  },

  data() {
    return {
      step: 'UploadXMLFile',
      measure: {
        providerName: this.moviment.fornecedor,
        dueDate: null,
        xml: null,
        typeOfPayment: null,
        noteValue: null,
        noteValueNet: null,
        valueTotal: 0,
        xmlJustify: '',
        jsonFile: null,
        selectedItens: [],
        attach: [],
        fileNames: [],
      },
      disableButtonSaveMeasure: false,
    }
  },

  computed: {
    ...mapGetters(['isManager', 'isAssistant']),
  },

  methods: {
    restartMeasure() {
      this.step = 'UploadXMLFile'
      this.measure = {
        providerName: this.moviment.fornecedor,
        dueDate: null,
        xml: null,
        typeOfPayment: null,
        noteValue: null,
        noteValueNet: null,
        valueTotal: 0,
        xmlJustify: '',
        jsonFile: null,
        selectedItens: [],
        attach: [],
        fileNames: [],
      }
    },

    forwardXMLReader(data) {
      this.step = 'MeasureItens'
      this.measure.dueDate = data.dueDate
      this.measure.xml = data.xml
      this.measure.typeOfPayment = data.typeOfPayment
      this.measure.noteValue = data.noteValue
      this.measure.noteValueNet = data.noteValueNet
      this.measure.xmlJustify = data.xmlJustify
      this.measure.jsonFile = data.jsonFile
      this.measure.attach = data.attach
      this.measure.fileNames = data.fileNames
    },

    fowardToSaveMeasure(data) {
      this.measure.totalValue = data.totalValue
      this.measure.selectedItens = data.selectedItens
      this.saveMeasure()
    },

    async saveMeasure() {
      try {
        this.disableButtonSaveMeasure = true

        const formData = new FormData()
        formData.append('idMov', this.moviment.id)
        formData.append('providerName', this.measure.providerName)
        formData.append('dueDate', this.measure.dueDate)
        formData.append('xml', this.measure.xml)
        formData.append(
          'typeOfPayment',
          JSON.stringify(this.measure.typeOfPayment),
        )
        formData.append('noteValue', this.measure.noteValue)
        formData.append('noteValueNet', this.measure.noteValueNet)
        formData.append('xmlJustify', this.measure.xmlJustify)
        formData.append('jsonFile', JSON.stringify(this.measure.jsonFile))
        formData.append(
          'selectedItens',
          JSON.stringify(this.measure.selectedItens),
        )
        const recalculateTotalValue = this.measure.selectedItens.reduce(
          (acc, item) => acc + item.totalValue,
          0,
        )
        formData.append('totalValue', recalculateTotalValue)
        formData.append('attach', JSON.stringify(this.measure.attach))
        formData.append('fileNames', JSON.stringify(this.measure.fileNames))

        const response = await this.$store.dispatch(
          'saveMovimentMeasure',
          formData,
        )

        this.$emit('getMeasures')
        this.restartMeasure()
        this.$root.$refs.notification.success(response.message)
        this.disableButtonSaveMeasure = false
      } catch (error) {
        this.disableButtonSaveMeasure = false
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },
  },
}
</script>
